import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { ZustandGeber } from "./zustand.tsx";
import "./styles.css";

const wurzel = document.getElementById("wurzel");
if (!wurzel) throw new Error("Element #wurzel fehlt in index.html.");

createRoot(wurzel).render(
  <StrictMode>
    <ZustandGeber>
      <App />
    </ZustandGeber>
  </StrictMode>,
);

// Service Worker nur im Betrieb anmelden. In der Entwicklung würde er den
// Vite-Zwischenspeicher überlagern und jede Änderung verschleiern.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // Ohne Service Worker läuft die App weiter, nur eben nicht offline.
    });
  });
}
